import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IHolidaySetting } from '@appshared';
import { ApprovalRequest, IApprovalRequest } from 'app/shared/model/approval-request.model';
import * as moment from 'moment';
import { Moment } from 'moment';
import * as business from 'moment-business';

@Injectable({
  providedIn: 'root',
})
export class NewApprovalRequestService {

  constructor() {}

  transformFormData(formGroup: FormGroup): IApprovalRequest {
    let result = new ApprovalRequest();
    Object.keys(formGroup.value).forEach(key => {
      if (!result.hasOwnProperty(key)) {
        return;
      }

      let value = formGroup.value[key];
      if (value instanceof moment) {
        value = value as moment.Moment;
        result[key] = <moment.Moment> value.toISOString();
      } else {
        result[key] = value;
      }
    });

    return result;
  }

  calculateNumberOfLeaveDays(startDate: Moment, endDate: Moment, holidays: Array<IHolidaySetting>): number {
    let totalLeaveDays = business.weekDays(startDate, endDate) + 1;
    let numberOfHoliday = this.countNumberOfHolidayInBetween(startDate, endDate, holidays);
    return totalLeaveDays - numberOfHoliday;
  }

  countNumberOfHolidayInBetween(startDate: Moment, endDate: Moment, holidays: Array<IHolidaySetting>) {
    let numberOfHoliday = 0;
    holidays.forEach((holidaySetting: IHolidaySetting) => {
      let holidayDate = holidaySetting.date;
      let holiday = moment().year(holidayDate[0]).month(holidayDate[1] - 1).date(holidayDate[2]);
      if (holiday.isBetween(startDate, endDate)) {
        numberOfHoliday++;
      }
    });

    return numberOfHoliday;
  }

  extractTimeFromString(time: string): object {
    let splitTime = time.split(":");
    if (splitTime && splitTime.length == 2) {
      return {
        hour: parseInt(splitTime[0]),
        minute: parseInt(splitTime[1])
      }
    }

    return {};
  }

  findNextWorkingDay(date: Moment, holidays: Array<string>): Moment {
    let result = date.add(1, "days");
    if (result.isoWeekday() > 5 || this.isHoliday(result, holidays)) {
      return this.findNextWorkingDay(result, holidays);
    }

    return result;
  }

  isHoliday(date: Moment, holidays: Array<string>): boolean {
    let dateInStr = date.format("YYYY-M-D");
    return holidays.indexOf(dateInStr) >= 0;
  }

  appendTimeToDate(date: Moment, time: string): Moment {
    const dateToAppend = date.clone();
    if (dateToAppend && time) {
      let parsedTime = this.extractTimeFromString(time);
      dateToAppend.set({
        hours: parsedTime["hour"] || 0,
        minutes: parsedTime["minute"] || 0,
        seconds: 0,
        milliseconds: 0
      });
    }

    return dateToAppend;
  }
}
